export default __webpack_public_path__ + "static/media/eventlocation-profile.d6a1f215.png";